import { NavLink, useLocation } from 'react-router-dom';
import { 
  FaHome, 
  FaThLarge, 
  FaBox, 
  FaInfoCircle, 
  FaPhone,
  FaWhatsapp,
  FaPlay
} from 'react-icons/fa';

const bottomNavItems = [
  { path: '/', label: 'Home', icon: FaHome },
  { path: '/products', label: 'Products', icon: FaBox },
  { path: '/demo', label: 'Demo', icon: FaPlay },
  { path: '/about', label: 'About', icon: FaInfoCircle },
];

export default function MobileBottomNav() {
  const location = useLocation();

  return (
    <>
      {/* Bottom Navigation - Fixed without horizontal scroll */}
      <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-md border-t border-gray-200/80 z-40 shadow-lg">
        <div className="flex justify-around items-center h-14 px-1 max-w-full">
          {bottomNavItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path || 
                            (item.path !== '/' && location.pathname.startsWith(item.path + '/'));
            
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive: active }) =>
                  `flex flex-col items-center justify-center transition-all duration-300 relative py-1 px-1 group min-w-[44px] flex-1 ${
                    active ? 'text-micropoint-gold' : 'text-gray-400 hover:text-micropoint-gold'
                  }`
                }
              >
                <div className={`relative transition-all duration-300 ${isActive ? 'scale-110' : 'group-hover:scale-110'}`}>
                  <Icon className={`text-lg sm:text-xl transition-all duration-300 ${isActive ? 'text-micropoint-gold drop-shadow-sm' : 'group-hover:text-micropoint-gold'}`} />
                  {isActive && (
                    <>
                      <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-5 h-1 bg-gradient-to-r from-micropoint-gold to-yellow-500 rounded-full" />
                      <span className="absolute -top-1 -right-1 w-1.5 h-1.5 bg-micropoint-gold rounded-full animate-pulse" />
                    </>
                  )}
                </div>
                <span className={`text-[9px] mt-0.5 font-medium transition-all duration-300 whitespace-nowrap ${
                  isActive ? 'text-micropoint-gold font-semibold' : 'text-gray-500 group-hover:text-micropoint-gold'
                }`}>
                  {item.label}
                </span>
              </NavLink>
            );
          })}
        </div>
        
        {/* Safe area spacer for notched phones */}
        <div className="h-safe-bottom bg-white/95 backdrop-blur-md" />
      </nav>

      {/* Quick Action Buttons - Floating above bottom nav */}
      <div className="lg:hidden fixed bottom-16 right-3 z-40 flex flex-col gap-2">
        <a 
          href="tel:+254703802020" 
          className="w-10 h-10 rounded-full bg-gradient-to-r from-micropoint-blue to-blue-600 text-white flex items-center justify-center shadow-lg hover:scale-110 transition-all duration-300 hover:shadow-xl"
          aria-label="Call us"
        >
          <FaPhone className="text-sm" />
        </a>
        <a 
          href="https://api.whatsapp.com/send?phone=254703802020" 
          target="_blank" 
          rel="noopener noreferrer"
          className="w-10 h-10 rounded-full bg-gradient-to-r from-green-500 to-green-600 text-white flex items-center justify-center shadow-lg hover:scale-110 transition-all duration-300 hover:shadow-xl"
          aria-label="WhatsApp"
        >
          <FaWhatsapp className="text-base" />
        </a>
      </div>
    </>
  );
}